/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Form as FormUi,
  Icon,
  Dropdown,
  Table,
  Checkbox,
  Input,
  Segment,
} from "semantic-ui-react";
import DatePicker from "react-datepicker";
import {
  withFormik,
  Form as Formiker,
  Field as Fieldmik,
  FieldArray,
} from "formik";
import moment from "moment";
import { isEmpty, values } from "lodash";
import { connect } from "react-redux";
import * as yup from "yup";
import ReadAxios from "../../axiosComponent/read";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { MyInput } from "../../dynamicComponent/myInputs";
import { translate } from "react-i18next";
import { AllRegex } from "../../../utils/validation";

const VehicleDetailsModal = ({
  values,
  isSubmitting,
  role,
  handleSubmit,
  test,
  setFieldValue,
  vehicleNumber,
  vehicleType,
  touched,
  OpenModal,
  CloseModal,
  errors,
  order,
  t,
  allotment_status,
  auth,
  ...props
}) => {
  const [isEditing, setisEditing] = useState(false);
  const [labelList, setLabelList] = useState([]);

  useEffect(() => {
    setFormHeader()
  }, []);

  const setFormHeader = () => {
    let headerList = [
      {
        headerType: '',
        mode: '',
        labels: [
          { labelName: 'Vendor', mandatory: '', display: '', element: 'input', type: '', name: '', },
          { labelName: 'Vehicle Number', mandatory: '', display: '', element: 'input', type: '', name: '', },
          { labelName: 'Ownership Type', mandatory: '', display: '', element: 'dropdown', type: '', name: '', },
          { labelName: 'Vehicle Type', mandatory: '', display: '', element: 'dropdown', type: '', name: '', },
          { labelName: 'Tracking Type', mandatory: '', display: '', element: 'dropdown', type: '', name: '', }
        ]
      },
      {
        headerType: 'Vehicle Documents',
        mode: '',
        labels: [
          { labelName: 'Vehicle Registration Date', mandatory: '', display: '', element: 'date', type: '', name: '', },
          { labelName: 'Permit Expiry Date', mandatory: '', display: '', element: 'date', type: '', name: '', },
          { labelName: 'PUC Expiry Date', mandatory: '', display: '', element: 'date', type: '', name: '', },
          { labelName: 'Road Tax Expiry Date', mandatory: '', display: '', element: 'date', type: '', name: '', },
          { labelName: 'Insurance Expiry Date', mandatory: '', display: '', element: 'date', type: '', name: '', },
          { labelName: 'Fitness Expiry Date', mandatory: '', display: '', element: 'date', type: '', name: '', },
        ]
      },
      {
        headerType: 'Driver Details',
        mode: '',
        labels: [
          { labelName: 'No. of Driver', mandatory: '', display: '', element: 'input', type: '', name: '', },
          { labelName: 'Driver License Number', mandatory: '', display: 'input', element: '', type: '', name: '', },
          { labelName: 'Driver Name', mandatory: '', display: '', element: 'input', type: '', name: '', },
          { labelName: 'Driver License Expiry Date', mandatory: '', display: '', element: 'date', type: '', name: '', },
          { labelName: 'Driver Phone Number', mandatory: '', display: '', element: 'input', type: '', name: '', },
          { labelName: 'Network Provider', mandatory: '', display: '', element: 'dropdown', type: '', name: '', },
        ]
      },
      {
        headerType: 'Vendor LR Details',
        mode: '',
        labels: [
          { labelName: 'Vendor LR No.', mandatory: '', display: '', element: 'input', type: '', name: '', },
          { labelName: 'Vendor LR Date', mandatory: '', display: '', element: 'date', type: '', name: '', }
        ]
      },
      {
        headerType: 'Cold Chain Details',
        mode: '',
        labels: [
          { labelName: 'Truck Type', mandatory: '', display: '', element: 'dropdown', type: '', name: '', },
          { labelName: 'Data Logger Available', mandatory: '', display: 'dropdown', element: '', type: '', name: '', },
          { labelName: 'Red Line Inside Container', mandatory: '', display: 'dropdown', element: '', type: '', name: '', },
          { labelName: 'Data Logger No.', mandatory: '', display: '', element: 'input', type: '', name: '', },
          { labelName: 'GPS Available', mandatory: '', display: '', element: 'dropdown', type: '', name: '', },
          { labelName: 'Data Logger Recalibration Date', mandatory: '', display: 'date', element: '', type: '', name: '', }
        ]
      }
    ]
    setLabelList(headerList)
  }

  let handleOpen = () => setmodalOpen(true);

  let handleClose = () => {
    OpenModal = false;
  };
  let handleSubmited = () => {
    handleSubmit();
  };

  return (
    <>
      <Modal
        open={OpenModal}
        onClose={CloseModal}
        size="fullscreen"
      >
        <Modal.Header className="p-bold-100 display-flex-center-justify-spacebtwn">
          <div className="width-45cent">
            <span>{t("title") || "Vehicle Details"}</span>
          </div>
          <div className="width-45cent display-flex-center-justify-flexend">
            {!isEditing && (
              <Button
                type="button"
                disabled={role == "Quality Control" ? true : false}
                onClick={() => setisEditing(true)}
                size="mini"
                basic
                icon
                className="w3-blue w3-round w3-hover-blue"
                style={{ borderColor: "transparent", boxShadow: 'none' }}
              >
                <Icon name="pencil alternate" />{" "}
                {t("action_button.edit") || "Edit"}
              </Button>
            )}
            {isEditing && (
              <Button
                type="button"
                onClick={() => setisEditing(false)}
                size="mini"
                basic
                icon
                className="w3-blue w3-round w3-hover-blue"
                style={{ borderColor: "transparent", boxShadow: 'none' }}
              >
                <Icon name="times" /> {t("action_button.cancel") || "Cancel"}
              </Button>
            )}
          </div>
        </Modal.Header>
        <Modal.Content>
          <Modal.Description>
            {isEditing ?
              (
                <div className="ui tiny form" style={{ border: 'transparent' }}>
                  <Formiker>
                    <div>
                      {labelList.map((item, index) => {
                        return (
                          <div key={index}>
                            <h2>
                              {item.headerType}
                            </h2>
                            <div className="display-flex-center-justify-spacebtwn flex-wrap">
                              {
                                item.labels.map((element, indx) => {
                                  return (
                                    <div className="display-flex-center-justify-spacebtwn width-40vw" key={element.labelName}>
                                      <div className="width-45cent">
                                        <label>{element.labelName}</label>
                                      </div>
                                      <div className="width-45cent">
                                        {element.element == 'dropdown' &&
                                          <>
                                            <Dropdown />
                                          </>}
                                        {element.element == 'date' &&
                                          <>
                                            <DatePicker
                                              isClearable
                                              popperClassName="dateTime"
                                              customInput={<Input defaultValue={props.defaultValue} className="dateWidth" icon="calendar alternate outline" iconPosition="right" />}
                                            />
                                          </>}
                                      </div>
                                    </div>
                                  )
                                })
                              }
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </Formiker>
                </div>
              ) : (
                <div className="ui tiny table" style={{ border: 'transparent' }}>
                  <Formiker>
                    <div>
                      {labelList.map((item, index) => {
                        return (
                          <div key={index}>
                            <h2>
                              {item.headerType}
                            </h2>
                            <div className="display-flex-center-justify-spacebtwn flex-wrap">
                              {
                                item.labels.map((element, indx) => {
                                  return (
                                    <div className="display-flex-center-justify-spacebtwn width-40vw" key={element.labelName}>
                                      <div className="width-45cent">
                                        <label>{element.labelName}</label>
                                      </div>
                                      <div className="width-45cent">
                                        <label>{element.labelName}</label>
                                      </div>
                                    </div>
                                  )
                                })
                              }
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </Formiker>
                </div>
              )}
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          {isEditing && (
            <Button
              type="submit"
              onClick={() => handleSubmited()}
              size="mini"
              className="w3-blue w3-round w3-hover-blue"
            >
              {t("action_button.submit") || "Submit"}
            </Button>
          )}
          <Button
            type="button"
            onClick={() => CloseModal(true)}
            size="mini"
            // className="w3-blue w3-round green"
            color="olive"
          >
            {t("action_button.close") || "Close"}
          </Button>
        </Modal.Actions>
        {/* </Formiker> */}
      </Modal>
    </>
  );
};
const FormikModalVehicleDetail = withFormik({
  mapPropsToValues(props) {
    return {
      vendor_name: props?.order?.vendor_name || "",
      vehicle_number: props?.order?.vehicle_number || "",
      ownership_type: props?.order?.ownership_type || "",
      vehicle_type: props?.order?.vehicle_type || "",
      tracking_type: props?.order?.tracking_type || "",
      vehicle_registration_Date: props?.order?.vehicle_registration_Date || "",
      permit_expiry_date: props?.order?.permit_expiry_date || "",
      pUC_expiry_date: props?.order?.pUC_expiry_date || "",
      road_tax_expiry_date: props?.order?.road_tax_expiry_date || "",
      insurance_expiry_date: props?.order?.insurance_expiry_date || "",
      fitness_expiry_date: props?.order?.fitness_expiry_date || "",
      No_of_driver: props?.order?.No_of_driver || "",
      driver_license_number: props?.order?.driver_license_number || "",
      driver_name: props?.order?.driver_name || "",
      driver_license_expiry_date: props?.order?.driver_license_expiry_date || "",
      driver_phone: props?.order?.driver_phone || "",
      network_provider: props?.order?.network_provider || "",
      vendor_lR_no: props?.order?.vendor_lR_no || "",
      vendor_lR_date: props?.order?.vendor_lR_date || "",
      truck_type: props?.order?.truck_type || "",
      data_logger_available: props?.order?.data_logger_available || "",
      red_line_inside_container: props?.order?.red_line_inside_container || "",
      data_logger_no: props?.order?.data_logger_no || "",
      gPS_available: props?.order?.gPS_available || "",
      data_logger_recalibration_date: props?.order?.data_logger_recalibration_date || "",
    };
  },
  validationSchema: yup.object({
    vendor_name: yup.string().nullable().optional(),
    vehicle_number: yup.string().nullable().optional(),
    ownership_type: yup.string().nullable().optional(),
    vehicle_type: yup.string().nullable().optional(),
    tracking_type: yup.string().nullable().optional(),
    vehicle_registration_Date: yup.string().nullable().optional(),
    permit_expiry_date: yup.string().nullable().optional(),
    pUC_expiry_date: yup.string().nullable().optional(),
    road_tax_expiry_date: yup.string().nullable().optional(),
    insurance_expiry_date: yup.string().nullable().optional(),
    fitness_expiry_date: yup.string().nullable().optional(),
    No_of_driver: yup.string().nullable().optional(),
    driver_license_number: yup.string().nullable().optional(),
    driver_name: yup.string().nullable().optional(),
    driver_license_expiry_date: yup.string().nullable().optional(),
    driver_phone: yup.string().nullable().optional(),
    network_provider: yup.string().nullable().optional(),
    vendor_lR_no: yup.string().nullable().optional(),
    vendor_lR_date: yup.string().nullable().optional(),
    truck_type: yup.string().nullable().optional(),
    data_logger_available: yup.string().nullable().optional(),
    red_line_inside_container: yup.string().nullable().optional(),
    data_logger_no: yup.string().nullable().optional(),
    gPS_available: yup.string().nullable().optional(),
    data_logger_recalibration_date: yup.string().nullable().optional(),
  }),
  handleSubmit(values, { setSubmitting, props, resetForm }) {
  },
})(VehicleDetailsModal);

const mapStateToProps = ({ auth }) => {
  return { auth };
};

export default connect(mapStateToProps, {
  successAlertDispatcher,
  errorAlertDispatcher,
})(translate("alloted_vehicle_details")(FormikModalVehicleDetail));
